export const CUSTOM_WATCHLIST_UPLOAD_SUPPORTED_FORMATS = {
  "text/csv": [".csv"],
};



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/constants/formValidations.js